import { Theme } from "@mui/material/styles";

export const getSnackbarComponents = (sunoTheme: Theme) => ({
  MuiSnackbarContent: {
    styleOverrides: {
      root: {
        backgroundColor: "#FFFFFF",
        color: "#000000",
        boxShadow: "0px 0px 10px 0px rgba(66, 68, 90, 1)",
        padding: `${sunoTheme.spacing(2)} ${sunoTheme.spacing(4)}`,
      },
    },
  },
});
